import { render, staticRenderFns } from "./BankGroupForm.vue?vue&type=template&id=17cecf34&"
import script from "./BankGroupForm.vue?vue&type=script&lang=js&"
export * from "./BankGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports